import { SupportedView } from '@apps/createWedding/components/View';
import { useAuth } from '@shared/components/AuthProvider';
import { authToUserDetails } from '@apps/createWedding/utils';

export const useDesiredView: () => SupportedView = () => {
  const auth = useAuth();
  const userDetails = authToUserDetails(auth);
  const { ownedEventWebsite } = userDetails;
  const { isLoggedIn, currentUser } = auth;

  if (isLoggedIn) {
    const socialProvider = currentUser.profile?.activeAlias?.provider ?? '';
    const email = currentUser.profile?.email;
    const isSocialLogin = ['facebook', 'google-oauth2', 'google-apps'].includes(socialProvider);
    const isJoyUser = email && email.indexOf('@withjoy.com') > -1;

    const shouldSocialRedirect = isSocialLogin && !isJoyUser && !ownedEventWebsite;

    if (shouldSocialRedirect) {
      return 'socialAccount';
    }
    return 'createWeddingForm';
  }

  return 'createAccount';
};
